import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const TIMEOUT_DELAY = 500;
const VIEW_THRESHOLD = 0.6;

interface ViewportImpressionTrackerProps {
  handleSendImpression: () => void;
}

export const ViewportImpressionTracker: FC<
  PropsWithChildren<ViewportImpressionTrackerProps>
> = ({ children, handleSendImpression }) => {
  const [ref, inView] = useInView({
    threshold: VIEW_THRESHOLD,
  });

  useEffect(() => {
    if (inView) {
      const timeout = setTimeout(() => {
        handleSendImpression();
      }, TIMEOUT_DELAY);

      return () => clearTimeout(timeout);
    }
  }, [handleSendImpression, inView]);

  return <div ref={ref}>{children}</div>;
};
